// A drawer's create or save runs in its footer, but the Escape guard belongs on the `Dialog.Content`
// the drawer renders, and that component must not re-render on field changes (see the form-store
// comment in each drawer). So the guard takes a check that reads the mutation cache at keypress,
// rather than an `isPending` flag that would re-render the drawer when the request starts and ends.
export const preventEscapeWhile = (getIsBusy: () => boolean) => (event: KeyboardEvent) => {
  if (getIsBusy()) {
    event.preventDefault()
  }
}
